"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditButton;

var React = _interopRequireWildcard(require("react"));

var _react2 = require("linaria/react");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const EditButtonContainer =
/*#__PURE__*/
(0, _react2.styled)("a")({
  name: "EditButtonContainer",
  class: "EditButtonContainer_emlbhqm"
});

function EditButton({
  github,
  filepath
}) {
  return github ? React.createElement(EditButtonContainer, {
    target: "_blank",
    href: `${github}/${filepath}`
  }, React.createElement("svg", {
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20"
  }, React.createElement("path", {
    fill: "none",
    transform: "translate(2.000000, 2.000000)",
    d: "M1.5,14.5363545 L1.5,11.3292488 L9.36649374,3.4627884 L12.5735698,6.66982438 L4.7071064,14.5363545 L1.5,14.5363545 Z M14.1535993,5.08986045 L12.5666426,6.67673666 L9.35957774,3.46971186 L10.9465031,1.88274634 C11.4083588,1.42089061 12.1250348,1.42089061 12.5868905,1.88274634 L14.1536082,3.44946407 C14.6154639,3.91131979 14.6154639,4.62799577 14.1536082,5.08985149 Z"
  }))) : null;
}
//# sourceMappingURL=EditButton.js.map

require('../css/src/templates/EditButton.css');
